var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar-nav',[(_vm.showSwitcher)?_c('KloosterModeSwitcher'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }